import { selectModals } from 'store/modals/selectors';

import { useSelector } from 'hooks';

import { MODAL_LIST } from './constants';

const Modals = () => {
    const { modalId, modalProps } = useSelector(selectModals);

    const ModalComponent = modalId ? MODAL_LIST[modalId] : null;

    if (!ModalComponent) {
        return null;
    }

    return <ModalComponent {...modalProps} />;
};

export default Modals;
